export const InitDropDowns = () => {
    const dropDownButtons = document.querySelectorAll('[data-toggle="dropdown"]');

    dropDownButtons.forEach((button) => {
        handleDropDown(button);
    });
};

const handleDropDown = (button) => {
    if (button) {
        let dropDownMenu = document.getElementById(button.getAttribute('data-target'));

        window.addEventListener('click', (event) => {
            if (!$(event.target).closest(dropDownMenu.parentElement).length && dropDownMenu.classList.contains('!block') && event.target.type !== 'radio') {
                dropDownMenu.classList.toggle('!block');
                toggleAngleIcon(button);
            }
        });

        button.addEventListener('click', () => {
            if (dropDownMenu.classList.contains('!block')) {
                dropDownMenu.classList.remove('!block');
            } else {
                dropDownMenu.classList.add('!block');
            }
            toggleAngleIcon(button);
        });

        // Variant dropdown: swap button content on open/close
        if (button.closest('.variants')) {
            const selected = button.querySelector('.variant-selected');
            const defaultEl = button.querySelector('.variant-default');

            if (selected && defaultEl && dropDownMenu) {
                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        if (mutation.attributeName === 'class') {
                            const isOpen = dropDownMenu.classList.contains('!block');
                            if (isOpen) {
                                selected.classList.add('opacity-0');
                                defaultEl.classList.remove('opacity-0');
                            } else {
                                selected.classList.remove('opacity-0');
                                defaultEl.classList.add('opacity-0');
                            }
                        }
                    });
                });

                observer.observe(dropDownMenu, { attributes: true });
            }
        }
    }
};

export const toggleAngleIcon = button => {
    let icon = button.querySelector('i[class*="fa-angle-"]');
    if (icon) {
        icon.classList.toggle("rotate-180");
    }
}

export const toggleAngle = (button, show) => {
    let icon = button.querySelector('i[class*="fa-angle-"]');
    if (!icon) return;

    if (show) {
        icon.classList.add("rotate-180");
    } else {
        icon.classList.remove("rotate-180");
    }
}
